var resources = require('items-view-strings');
    var strings = resources['_U794z/V4Yk4dK01T0aO4lQ'];
export { strings };
export default strings;
